export function toCSV(polygon) {
  const header = "id,name,sequence,lon,lat,alt\n";
  const rows = polygon.coordinates
    .map(
      (c) => `${polygon.id},${polygon.name},${c.sequence},${c.x},${c.y},${c.z}`
    )
    .join("\n");
  return header + rows;
}
